import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import i18n from '../../i18n';
import axios from 'axios/axios-base';
import 'components/transactionEditor/RequestNodeWidget.css';
import { Col, Modal } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import CopyToClipboardButton from '../buttons/CopyToClipboardButton';
import { BodyMatcherItem, MatcherPathItem, XmlNamespaceItem } from './BodyMatchersList';
import { getUniqueIndex } from './RequestMatchersList';
import { BlazeDropdownItem } from '../ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import _ from 'lodash';
import SimpleLoader from '../loaders/SimpleLoader';
import { showToastNotification } from '../../store/ui/toasts/toastsActions';
import RequestTreeWizard from './RequestTreeWizard';
import HelpTooltip from '../overlays/helpTooltip/HelpTooltip';
import { extractNameSpaceFromXmlString, getXmlObject } from '../../utils/xmlUtil';
import { isJsonString } from '../../utils/jsonUtil';
import format from 'xml-formatter';
import BzmIcon from '../icons/BzmIcon';
import {
  containsNameSpace,
  generateDirectPathInTree,
  getAttributesValuesFromBodyMatcher,
  getIndexOfMatcherFromAttribute,
  getIndexOfMatcherFromLeaf,
  getJsonPathForNodeInTree,
  getValuesFromBodyMatcher,
  getXpathForNodeInTree,
  matcherTypesDropdownItems,
  specificMatcherItem,
} from '../../utils/requestWidgetUtils';
import CheckBox from '../ui/checkBox/CheckBox';
import { AttributeMatch } from './Wizards/AttributeMatcher/AttributeNode';
import CDataDropdown, { CdataSelectedCounts } from './Wizards/CDataMatcher/CDataDropdown';
import Row from 'react-bootstrap/Row';
import { Matcher } from '../../types/rest/dslTypes';
import { Base64 } from 'js-base64';
import clsx from 'clsx';

export type RequestNodeWidgetType = 'json' | 'xpath' | 'wsdl' | 'cdata_xpath';

interface StateProps {
  showWidget: boolean;
  content: string;
  uniqueNamespacePrefixes: string[];
  namespacesAddedToMatcher: XmlNamespaceItem[];
  /** Selection for standard Xpath matcher */
  selectedNodes: SelectedElements[];
  /** Selection for CData matcher (each CData block selection is in the Map) */
  cdataSelectedNodes: { [key: string]: CDataSelection };
  leafNodeMatcherValues: LeafNodeMatcherValue[];
  /** UI Tree representation of the json tree content. Generated by backend. */
  sampleBodyJsonUi: string;
  cdataTreeDto: CdataTreeDto | null;
  selectedCdataItem: BlazeDropdownItem | null;
  cdataItems: BlazeDropdownItem[];
  isTreeReady: boolean;
  sampleBodyParsingErrors: string;
  /** Drives Xpath namespaces configuration, namespaces are not ignored by default. */
  ignoreNameSpaces: boolean;
  containsNameSpace: boolean;
  uniqueNamespaces: string[];
  cdataSelectedCounts?: CdataSelectedCounts;
}

interface LocalProps {
  id: string;
  sampleBody: string;
  isReadOnly?: boolean;
  type: RequestNodeWidgetType;
  onAdd: () => void;
  xmlNamespaceList: XmlNamespaceItem[];
  updateXPathContent: (
    matcher: MatcherPathItem[],
    type: RequestNodeWidgetType,
    namespaces?: any[],
    sampleBody?: string,
  ) => void;
  /** Persists just the sample body text (no matchers) — called on any close that isn't "Select". */
  updateSampleBody?: (sampleBody: string) => void;
  bodyMatcherList: BodyMatcherItem[];
}

interface LeafNodeMatcherValue {
  id: number;
  matchType: string;
  matchValue: string;
  cdataXpath: string | null;
  attributesNode?: AttributesNodeMatcherValue[];
}

interface CDataSelection {
  selection: SelectedElements[];
  isDirty: boolean;
}

export interface AttributesNodeMatcherValue {
  id: number;
  matchType: string;
  matchValue: string;
  cdataXpath: string | null;
}

export interface SelectedElements {
  id: number;
  attributesId?: number[];
}

export interface AttrNode {
  id: number;
  name: string;
  value: string;
}

export interface CdataTreeDto {
  namespaces: XpathMatcherNamespace[];
  cdata: CdataContentDto[];
}

export interface XpathMatcherNamespace {
  prefix: string;
  uri: string;
}

export interface CdataContentDto {
  cdataXpath: string;
  cdataContent: string;
  isValidXml: boolean;
  encodedJsonUiTree: string;
}

const matcherSpecific = 'Specific';
const matcherAnything = 'Anything';

const defaultCdataCounts = {
  items: {},
  total: 0,
};

enum CounterUpdateType {
  Increment,
  Decrement,
}

class RequestNodeWidget extends Component<AllProps, StateProps> {
  state = {
    showWidget: false,
    content: '',
    uniqueNamespacePrefixes: [] as string[],
    namespacesAddedToMatcher: [] as XmlNamespaceItem[],
    selectedNodes: [] as SelectedElements[],
    cdataSelectedNodes: {} as { [key: string]: CDataSelection },
    leafNodeMatcherValues: [] as LeafNodeMatcherValue[],
    sampleBodyJsonUi: '',
    cdataTreeDto: null as CdataTreeDto,
    selectedCdataItem: null as BlazeDropdownItem,
    cdataItems: [] as BlazeDropdownItem[],
    isTreeReady: false,
    sampleBodyParsingErrors: '',
    ignoreNameSpaces: false,
    containsNameSpace: false,
    uniqueNamespaces: [],
    cdataSelectedCounts: defaultCdataCounts,
  };

  buildCdataItems = (cdataTreeDto: CdataTreeDto): BlazeDropdownItem[] => {
    if (!cdataTreeDto || !cdataTreeDto.cdata || cdataTreeDto.cdata.length == 0) {
      return [];
    }

    const list = _.map(cdataTreeDto.cdata, (cdataContent, key) => ({
      id: key,
      name: cdataContent.cdataXpath,
    }));

    return list;
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.showWidget === true && this.props.sampleBody !== nextProps.sampleBody) {
      this.setState({ content: nextProps.sampleBody }, () => {
        if (this.props.type === 'cdata_xpath') {
          this.parseXmlForCdataTree(nextProps.sampleBody);
        } else {
          this.convertContent(nextProps.sampleBody, true);
        }
      });
    }
  }

  convertContent = async (content: string, performBase64Encode: boolean) => {
    if (content !== '') {
      this.setState({
        isTreeReady: false,
      });
      const type = this.props.type === 'json' ? 'json' : 'xml';
      if (content) {
        try {
          const response = await axios.post(
            '/workspaces/{workspaceId}/ui/transactions/convert-to-tree?sourceType=' + type,
            performBase64Encode ? Buffer.from(content).toString('base64') : content,
            {
              headers: {
                'Content-Type': 'text/plain',
                Accept: 'application/json',
              },
            },
          );
          this.setState({
            sampleBodyJsonUi: Buffer.from(response.data.result, 'base64').toString(),
            isTreeReady: true,
            sampleBodyParsingErrors: '',
          });

          this.initializeLeafNodeValues();
        } catch (error) {
          this.setState({
            isTreeReady: true,
            sampleBodyJsonUi: '',
            selectedNodes: [] as SelectedElements[],
            cdataSelectedNodes: {} as { [key: string]: CDataSelection },
            sampleBodyParsingErrors: _.get(error, 'response.data.error', error.toString()),
          });
        }
      }
    }
  };

  buildNamespaceItems = (cdataTreeDto: CdataTreeDto): XmlNamespaceItem[] => {
    if (_.isNil(cdataTreeDto.namespaces)) {
      return [];
    }
    return _.map(
      cdataTreeDto.namespaces,
      (ns: XpathMatcherNamespace, index: number) =>
        ({
          id: String(index),
          prefix: Base64.decode(ns.prefix),
          uri: Base64.decode(ns.uri),
        } as XmlNamespaceItem),
    );
  };

  parseXmlForCdataTree = (content: string) => {
    if (content !== '') {
      this.setState({
        isTreeReady: false,
      });

      if (content) {
        axios
          .post('/workspaces/{workspaceId}/ui/transactions/convert-cdata-to-tree', content, {
            headers: {
              'Content-Type': 'application/xml',
              Accept: 'application/json',
            },
          })
          .then(async response => {
            // Build the CData dropdown list items
            const cdataTreeDto: CdataTreeDto = response.data.result;
            const cdataItems = this.buildCdataItems(cdataTreeDto);
            const namespaceItems: XmlNamespaceItem[] = this.buildNamespaceItems(cdataTreeDto);

            //Prepopulate selected map for cdata items
            const cdataSelectedItems = {};
            _.forEach(cdataItems, item => _.assign(cdataSelectedItems, { [item.name]: [] }));

            // Precompute the selected nodes across all CData sections based on the number of CData XPath matches
            let total = 0;
            let cdataSelectedCounts = defaultCdataCounts;

            if (this.props.type === 'cdata_xpath') {
              const cdataBlockCounts = {};

              _.forEach(this.props.bodyMatcherList, bodyMatcher => {
                /**
                 * Do not include matchers that aren't CData XPath matchers or if it is a newly created matcher,
                 * in which case the CData XPath value would not yet be set, or if the existing matcher is not in the sample XML
                 */
                const doesMatcherCDataExist = !_.isEmpty(
                  _.filter(cdataItems, cdataItem => cdataItem.name === bodyMatcher.cdataXpath),
                );

                if (
                  bodyMatcher.matcher !== Matcher.matches_xml_cdata ||
                  _.isNil(bodyMatcher.cdataXpath) ||
                  !doesMatcherCDataExist
                ) {
                  return;
                }

                const cdataTotal = _.isNil(cdataBlockCounts[bodyMatcher.cdataXpath])
                  ? 0
                  : cdataBlockCounts[bodyMatcher.cdataXpath];

                cdataBlockCounts[bodyMatcher.cdataXpath] = cdataTotal + 1;
                total++;
              });

              cdataSelectedCounts = {
                items: cdataBlockCounts,
                total: total,
              };
            }

            await this.setState({
              cdataTreeDto: cdataTreeDto,
              isTreeReady: true,
              sampleBodyParsingErrors: '',
              cdataItems: cdataItems,
              cdataSelectedNodes: cdataSelectedItems,
              cdataSelectedCounts: cdataSelectedCounts,
              namespacesAddedToMatcher: namespaceItems,
            });

            const selectedCdataItem = !cdataItems || cdataItems.length == 0 ? null : cdataItems[0];
            await this.handleCdataItemSelection(selectedCdataItem);
          })
          .catch(error => {
            this.setState({
              isTreeReady: true,
              sampleBodyJsonUi: '',
              cdataTreeDto: null,
              cdataItems: [],
              selectedCdataItem: null,
              selectedNodes: [] as SelectedElements[],
              cdataSelectedNodes: {} as { [key: string]: CDataSelection },
              cdataSelectedCounts: defaultCdataCounts,
              sampleBodyParsingErrors: _.get(error, 'response.data.error', error.toString()),
            });
          });
      }
    }
  };

  preselectAttributesBasedOnMatcherData = (
    selectedItems: SelectedElements[],
    element: any,
    nodeTreepath: any,
    cdataXpathSelected: any,
    bodyMatcherList: BodyMatcherItem[],
  ): BodyMatcherItem[] => {
    const type = this.props.type;

    //check which of its attributes should be selected
    let matcherListClone = _.cloneDeep(bodyMatcherList);
    if (element.attributesNode !== undefined && _.isArray(element.attributesNode)) {
      element.attributesNode.forEach(attr => {
        const matcherIndex = getIndexOfMatcherFromAttribute(
          attr,
          matcherListClone,
          type,
          nodeTreepath,
          cdataXpathSelected,
        );
        if (matcherIndex !== -1) {
          const foundElement = selectedItems.find(item => item.id === element.id);
          if (foundElement !== undefined) {
            foundElement.attributesId.push(attr.id);
          } else {
            selectedItems.push({ id: element.id, attributesId: [attr.id] } as SelectedElements);
          }
          matcherListClone = matcherListClone.filter((matcher, i) => i !== matcherIndex);
        }
      });
    }
    return matcherListClone;
  };

  preselectNodesBasedOnMatcherData = (
    selectedItems: SelectedElements[],
    element: any,
    nodeTreepath: any,
    cdataXpathSelected: any,
    bodyMatcherList: BodyMatcherItem[],
  ): BodyMatcherItem[] => {
    const type = this.props.type;
    //check if item should be also selected
    const indexOfMatcherFromLeaf = getIndexOfMatcherFromLeaf(
      element,
      bodyMatcherList,
      type,
      nodeTreepath,
      cdataXpathSelected,
    );
    if (indexOfMatcherFromLeaf !== -1) {
      const foundElement = selectedItems.find(item => item.id === element.id);
      if (foundElement !== undefined) {
        foundElement.attributesId.push(-1);
      } else {
        //attributeId -1 refers to the row itself and not any attribute, marked as checked
        selectedItems.push({ id: element.id, attributesId: [-1] } as SelectedElements);
      }
      bodyMatcherList = bodyMatcherList.filter((matcher, i) => i !== indexOfMatcherFromLeaf);
    }

    return bodyMatcherList;
  };

  isSelectButtonDisabled = () => {
    return !this.state.isTreeReady;
  };

  handleCdataItemSelection = async (cdataSectionItem: BlazeDropdownItem) => {
    // Save the selection of attributes of the previous CData section
    const prevCdataItem = _.cloneDeep(this.state.selectedCdataItem);
    const prevSelectedItems = _.cloneDeep(this.state.selectedNodes);
    const cdataSelectedNodes = this.state.cdataSelectedNodes ? _.cloneDeep(this.state.cdataSelectedNodes) : {};

    if (!_.isNil(prevCdataItem)) {
      _.assign(cdataSelectedNodes[prevCdataItem.name], { selection: _.cloneDeep(prevSelectedItems) });
    }

    const newSelectedItems =
      cdataSectionItem?.name &&
      !_.isNil(cdataSelectedNodes[cdataSectionItem.name]) &&
      !_.isNil(cdataSelectedNodes[cdataSectionItem.name].selection)
        ? cdataSelectedNodes[cdataSectionItem.name].selection
        : [];

    // Store the CData entry that has been selected and any changes to the selected nodes
    await this.setState({
      selectedCdataItem: cdataSectionItem,
      cdataSelectedNodes: cdataSelectedNodes,
      selectedNodes: newSelectedItems,
    });

    // Refresh the node tree based on the newly selected CData item
    this.refreshTreeFromCdataItemSelection(cdataSectionItem);
  };

  /**
   * Refreshed XML node tree based on the CData section node that was selected
   */
  refreshTreeFromCdataItemSelection = (cdataSectionItem: BlazeDropdownItem) => {
    // If the item is not valid or there is no CData tree that was parsed from the sample XML,
    // simply do nothing (no-op)
    if (!cdataSectionItem || !cdataSectionItem.name || !this.state.cdataTreeDto) {
      return;
    }

    // Find the actual CdataContentDto object that matches the value/XPath of the selected CData section item
    const cdataContentDto: CdataContentDto = _.find(
      this.state.cdataTreeDto.cdata,
      content => content.cdataXpath === cdataSectionItem.name,
    );

    if (!cdataContentDto) {
      return;
    }

    // Update the state to use the encoded JSON UI tree that was already parsed
    // and initialize the leaf nodes when done
    this.setState(
      {
        sampleBodyJsonUi: Buffer.from(cdataContentDto.encodedJsonUiTree, 'base64').toString(),
        isTreeReady: true,
        sampleBodyParsingErrors: '',
      },
      this.initializeLeafNodeValues,
    );
  };

  /** Checks if currently selected CData item is dirty. */
  isCurrentCdataSelectionDirty = () => {
    const selectedCdataItem = this.state.selectedCdataItem;
    return _.get(this.state.cdataSelectedNodes[selectedCdataItem.name], 'isDirty');
  };

  /**
   * Creates matcher data from JSON tree representation.
   */
  initializeLeafNodeValues = () => {
    let treeData: any = [];
    treeData = this.state.sampleBodyJsonUi ? JSON.parse(this.state.sampleBodyJsonUi) : treeData;
    const array = [] as LeafNodeMatcherValue[];
    const selectedItems: SelectedElements[] = [] as SelectedElements[];
    let treeContainsNameSpace = false;

    const cdataXpathSelected: string = this.state.selectedCdataItem ? this.state.selectedCdataItem.name : null;
    const { type } = this.props;
    // CData sections are edited as one shared session across every matches_xml_cdata row (see
    // handleChangeMultipleValues in BodyMatchersList), so preselection there must see every row of
    // that type. For json/xpath, preselect from this row's own "family" (itself and any sibling
    // rows a previous wizard invocation on this row generated) plus any other row whose saved
    // matcher was generated against the sample body currently shown in THIS wizard session — but
    // not rows with genuinely different sample body content, which must stay unaffected by each
    // other. Compare against this.state.content (what's on screen right now), not
    // this.props.sampleBody (the row's last-saved sample body): on a brand-new row, the user pastes
    // a sample and clicks "Build Tree" before ever saving anything, so props.sampleBody is still
    // empty/stale at the moment this preselection scan needs to see sibling rows sharing that
    // not-yet-saved content.
    const relevantMatcherList =
      this.props.type === 'cdata_xpath'
        ? this.props.bodyMatcherList
        : this.props.bodyMatcherList.filter(
            matcher =>
              matcher.id === this.props.id ||
              matcher.id.startsWith(this.props.id + '-') ||
              (this.state.content && matcher.resolvedSampleBody === this.state.content),
          );
    let matcherListClone = _.cloneDeep(relevantMatcherList);
    let matcherListForAttributes = _.cloneDeep(relevantMatcherList);
    let matcherListCloneNodes = _.cloneDeep(relevantMatcherList);
    let matcherListForNodes = _.cloneDeep(relevantMatcherList);
    treeData.forEach((element: any) => {
      const nodeTreepath = generateDirectPathInTree(treeData, element.id);
      const attrMatchAndValueList: AttributesNodeMatcherValue[] = [];
      if (element.attributesNode !== undefined && _.isArray(element.attributesNode)) {
        element.attributesNode.forEach(attr => {
          if (type === 'xpath') {
            const { attributesValuesFromBodyMatcher, attributeMatcherList } = getAttributesValuesFromBodyMatcher(
              attr,
              matcherListForAttributes,
              type,
              nodeTreepath,
              null,
              this.state.content,
            );
            matcherListForAttributes = attributeMatcherList;
            attrMatchAndValueList.push(attributesValuesFromBodyMatcher);
          } else if (type === 'cdata_xpath') {
            const { attributesValuesFromBodyMatcher, attributeMatcherList } = getAttributesValuesFromBodyMatcher(
              attr,
              matcherListForAttributes,
              type,
              nodeTreepath,
              cdataXpathSelected,
              this.state.content,
            );
            matcherListForAttributes = attributeMatcherList;
            attrMatchAndValueList.push(attributesValuesFromBodyMatcher);
          }
        });
      }
      const { bodyMatcherValues, matcherListNodes } = getValuesFromBodyMatcher(
        element,
        matcherListForNodes,
        type,
        nodeTreepath,
        cdataXpathSelected,
        this.state.content,
      );
      matcherListForNodes = matcherListNodes;
      array.push({
        id: element.id,
        matchType: bodyMatcherValues.matchType,
        matchValue: bodyMatcherValues.matchValue,
        cdataXpath: bodyMatcherValues.cdataXpath,
        attributesNode: attrMatchAndValueList,
      });

      // Do the preselection based on existing matchers for standard Xpath matcher and for CData in case user has not done
      // any selection within existing CData block
      if (
        this.props.type !== 'cdata_xpath' ||
        (this.props.type === 'cdata_xpath' && !this.isCurrentCdataSelectionDirty())
      ) {
        matcherListCloneNodes = this.preselectNodesBasedOnMatcherData(
          selectedItems,
          element,
          nodeTreepath,
          cdataXpathSelected,
          matcherListCloneNodes,
        );
        matcherListClone = this.preselectAttributesBasedOnMatcherData(
          selectedItems,
          element,
          nodeTreepath,
          cdataXpathSelected,
          matcherListClone,
        );
      }

      //Check if there is a namespace in this element
      if (this.props.type === 'xpath' && treeContainsNameSpace === false) {
        treeContainsNameSpace = containsNameSpace(element.name);
      } else if (this.props.type === 'cdata_xpath' && treeContainsNameSpace === false) {
        treeContainsNameSpace = containsNameSpace(element.name);
      }
    });

    // Check if there is existing/cached selected data to reuse when dealing with CData sections
    // If so, let's merge it into the selected item list
    const cdataSelectedNodes: { [key: string]: CDataSelection } = !_.isNil(this.state.cdataSelectedNodes)
      ? this.state.cdataSelectedNodes
      : {};
    let mergedSelectedItems = selectedItems;
    if (cdataXpathSelected) {
      const cachedSelectedItemsForCdata =
        !_.isNil(cdataSelectedNodes[cdataXpathSelected]) && !_.isNil(cdataSelectedNodes[cdataXpathSelected].selection)
          ? cdataSelectedNodes[cdataXpathSelected].selection
          : [];

      // Update selected items with the union of the cached items, filtering out any duplicates
      mergedSelectedItems = _.cloneDeep(_.uniqBy(_.union(selectedItems, cachedSelectedItemsForCdata), item => item.id));

      cdataSelectedNodes[cdataXpathSelected] = {
        selection: mergedSelectedItems,
        isDirty: true,
      };
    }

    this.setState({
      leafNodeMatcherValues: array,
      selectedNodes: mergedSelectedItems,
      containsNameSpace: treeContainsNameSpace,
      cdataSelectedNodes: cdataSelectedNodes,
    });

    if (treeContainsNameSpace) {
      this.extractXmlNamespacesFromXmlSample();
    }
  };

  closeModal = () => {
    // Prevent a rebuild queued by earlier typing from firing later (e.g. reopening the wizard against a
    // different sample body) and silently reconverting stale content — see formatContentDebounced.
    this.formatContentDebounced.cancel();
    // Persist the sample body text on every way out of the modal that isn't "Select" (Cancel,
    // backdrop click, Esc, the header close button all funnel here via onHide) so content the
    // user typed/built with "Build Tree" isn't silently lost — only the tree-derived matchers
    // still require an explicit "Select". Skip the write when it wouldn't change anything.
    if (this.props.updateSampleBody && this.state.content !== this.props.sampleBody) {
      this.props.updateSampleBody(this.state.content);
    }
    this.setState({
      showWidget: false,
      selectedNodes: [],
      cdataSelectedNodes: {},
    });
  };

  openWidget = () => {
    // Discard any rebuild armed by typing in a previous session of this widget before it's reused.
    this.formatContentDebounced.cancel();
    const content = this.props.sampleBody != null ? this.props.sampleBody : this.state.content;
    this.setState({
      content: content,
      isTreeReady: true,
    });

    if (content !== '') {
      if (this.props.type === 'cdata_xpath') {
        this.parseXmlForCdataTree(content);
      } else {
        this.convertContent(content, true);
      }
    }
    this.setState({ showWidget: true });
  };

  handleChange = (e: any) => {
    const target = e.target as HTMLInputElement;
    this.setState(
      {
        content: target.value,
      },
      () => {
        this.formatContentDebounced();
      },
    );
  };

  formatContentDebounced = _.debounce(() => {
    // A rebuild armed by typing can land well after the user has moved on to checking nodes and
    // filling in match values — initializeLeafNodeValues() only re-selects nodes already backed by a
    // saved matcher, so firing here would silently wipe an in-progress, not-yet-saved selection out
    // from under the user right before they click "Select" (producing an empty matcher). Skip the
    // automatic rebuild once a selection is in progress; the explicit "Build Tree" button still
    // rebuilds unconditionally.
    if (this.state.selectedNodes.length > 0) {
      return;
    }
    this.formatContent();
  }, 2500);

  formatContent = async () => {
    await this.validateContent(this.state.content);
    if (this.state.sampleBodyParsingErrors.trim().length === 0) {
      if (this.props.type === 'cdata_xpath') {
        this.parseXmlForCdataTree(this.state.content);
      } else {
        this.convertContent(this.state.content, true);
      }
    }
  };

  clearContent = () => {
    this.setState({
      content: '',
      sampleBodyParsingErrors: '',
      cdataItems: [],
      cdataSelectedNodes: null,
      cdataSelectedCounts: defaultCdataCounts,
      selectedNodes: null,
      selectedCdataItem: null,
      leafNodeMatcherValues: [],
      sampleBodyJsonUi: '',
    });
  };

  prettifyContent = () => {
    try {
      if (
        this.props.type === 'json' &&
        this.state.content.length > 0 &&
        this.state.sampleBodyParsingErrors.trim().length === 0
      ) {
        const obj = JSON.parse(this.state.content);
        this.setState({
          content: JSON.stringify(obj, null, 4),
        });
      } else if (
        this.props.type === 'xpath' &&
        this.state.content.length > 0 &&
        this.state.sampleBodyParsingErrors.trim().length === 0
      ) {
        this.setState({
          content: format(this.state.content),
        });
      } else if (
        this.props.type === 'cdata_xpath' &&
        this.state.content.length > 0 &&
        this.state.sampleBodyParsingErrors.trim().length === 0
      ) {
        this.setState({
          content: format(this.state.content),
        });
      }
    } catch (error) {
      console.error('Error encountered while pretty printing the content' + error);
    }
  };

  validateContent = (content: string) => {
    const type = this.props.type === 'json' ? 'json' : 'xml';
    if (type === 'xml') {
      const domObj = getXmlObject(content);
      if (domObj.getElementsByTagName('parsererror').length !== 0) {
        this.setState({ sampleBodyParsingErrors: 'Invalid XML entered.' });
      } else {
        this.setState({ sampleBodyParsingErrors: '' });
      }
    } else if (type === 'json') {
      // Check if content is json
      if (isJsonString(content)) {
        this.setState({ sampleBodyParsingErrors: '' });
      } else {
        this.setState({ sampleBodyParsingErrors: 'Invalid JSON entered.' });
      }
    }
  };

  /** Copies the current selection of nodes of the currently selected CData xpath
   *  in the local state to CData map. the location in Cdata map. */
  copyCurrentSelectionToCDataMap = async () => {
    const currentSelection: SelectedElements[] = _.cloneDeep(this.state.selectedNodes);
    const currentXpath: BlazeDropdownItem = _.cloneDeep(this.state.selectedCdataItem);
    const cdataSelectionMap = _.cloneDeep(this.state.cdataSelectedNodes);
    cdataSelectionMap[currentXpath.name] = {
      selection: currentSelection,
      isDirty: true,
    };
    await this.setState({ cdataSelectedNodes: cdataSelectionMap });
  };

  /**
   * Goes through selected nodes in json / xml and creates matchers for selected ones.
   */
  selectNodes = async () => {
    // Don't let a rebuild armed by earlier typing fire after this selection has already been read below.
    this.formatContentDebounced.cancel();

    let matchers: MatcherPathItem[] = [];

    // If we are dealing with CData XPath matchers, we need to go through all the CData sections
    if (this.props.type === 'cdata_xpath') {
      //Syncs currently selected nodes in CData with the map before proceeding
      await this.copyCurrentSelectionToCDataMap();

      _.forOwn(this.state.cdataSelectedNodes, (value, cdataXpath) => {
        // Find the actual CdataContentDto object that matches the value/XPath of the current CData section
        const cdataContentDto: CdataContentDto = _.find(
          this.state.cdataTreeDto.cdata,
          content => content.cdataXpath === cdataXpath,
        );

        const selectedNodes: SelectedElements[] = !_.isNil(value.selection) ? _.cloneDeep(value.selection) : [];
        _.forEach(selectedNodes, (node, index) => {
          const nodeTree = generateDirectPathInTree(
            JSON.parse(Buffer.from(cdataContentDto.encodedJsonUiTree, 'base64').toString()),
            node.id,
          );

          //Transform path of nodes to xpath
          node.attributesId.forEach(attr => {
            const path = this.generateNodePathFromTreeArray(nodeTree, node.id, attr);
            matchers.push({
              value: path,
              id: index === 0 ? this.props.id : this.props.id + '-' + index,
              cdataXpath: cdataXpath,
            });
          });
        });
      });

      // Check to see if there are an CData sections that didn't have their body matchers modified
      // If so, add them to the list of matchers to save so that they are not lost/overwritten
      _.forEach(this.props.bodyMatcherList, bm => {
        if (
          !_.isNil(bm.content) && // Ignore empty body matcher (Usually it is brand-new item in the list)
          bm.matcher == Matcher.matches_xml_cdata &&
          (_.isNil(this.state.cdataSelectedNodes[bm.cdataXpath]) ||
            !this.state.cdataSelectedNodes[bm.cdataXpath].isDirty)
        ) {
          // Check if the existing CData XPath body matcher still references a valid CData section
          // This might not be the case if the sample XML has changed
          if (!_.isEmpty(_.filter(this.state.cdataItems, cdataItem => cdataItem.name === bm.cdataXpath))) {
            const matcherPathItem: MatcherPathItem = {
              id: bm.id,
              value: bm.content,
              cdataXpath: bm.cdataXpath,
            };

            matchers.push(matcherPathItem);
          }
        }
      });

      // Finally, sort the list of matchers by CData XPath
      matchers = _.sortBy(matchers, ['cdataXpath']);
    } else if (this.state.sampleBodyJsonUi) {
      //Generate path from nodes at first
      const selectedNodes: SelectedElements[] = this.state.selectedNodes;
      selectedNodes.forEach((node, index) => {
        const nodeTree = generateDirectPathInTree(JSON.parse(this.state.sampleBodyJsonUi), node.id);

        //Transform path of nodes to xpath
        node.attributesId.forEach(attr => {
          const path = this.generateNodePathFromTreeArray(nodeTree, node.id, attr);
          matchers.push({
            value: path,
            id: index === 0 ? this.props.id : this.props.id + '-' + index,
            cdataXpath: null,
          });
        });
      });
    }

    //Remove duplicate expressions (there might be multiple nodes with same value)
    matchers = _.uniqWith(matchers, (left, right): boolean => {
      return left.value === right.value && left.cdataXpath === right.cdataXpath;
    });

    // Get namespaces from current xml in the tree, combine it with namespaces
    // coming through props (there might be some namespaces manually created by user) and propagate up
    const namespaceItems: XmlNamespaceItem[] = this.getAllUniqueNamespaces();

    // Pass the sample body along with the matchers in this single atomic update so the row(s)
    // this wizard session produces keep the sample body that was used to generate them, instead
    // of relying on a second, separately-dispatched update that a stale list snapshot could undo.
    await this.props.updateXPathContent(matchers, this.props.type, namespaceItems, this.state.content);

    this.setState({
      selectedNodes: [] as SelectedElements[],
      cdataSelectedNodes: {},
      showWidget: false,
    });
  };

  /**
   * Reads XML string, extracts namespaces from it and saves to local state.
   * */
  extractXmlNamespacesFromXmlSample = () => {
    if (!_.isNil(this.state.content)) {
      //Read list of namespaces from provided XML
      const nameSpaces = extractNameSpaceFromXmlString(this.state.content);
      _.forEach(nameSpaces, (namespaceUri, prefix) => {
        this.addToNamespaceList(prefix, namespaceUri);
      });
    }
  };

  addToNamespaceList = (prefix: string, value: string) => {
    if (!_.includes(this.state.uniqueNamespacePrefixes, prefix)) {
      const newList = _.cloneDeep(this.state.uniqueNamespacePrefixes);
      newList.push(prefix);
      const uniqueIndex = getUniqueIndex(this.props.xmlNamespaceList);
      const newXmlNamespace: XmlNamespaceItem[] = _.cloneDeep(this.state.namespacesAddedToMatcher);
      newXmlNamespace.push({
        id: 'new-xml-namespace-auto-' + prefix + '-' + uniqueIndex,
        prefix: prefix,
        uri: value,
      });

      this.setState({
        uniqueNamespaces: newList,
        namespacesAddedToMatcher: newXmlNamespace,
      });
    }
  };

  /**
   * Concatenates newly created namespace items with already existing ones which were originally passed through props.
   */
  getAllUniqueNamespaces = () => {
    const list = this.props.xmlNamespaceList
      ? this.props.xmlNamespaceList.concat(this.state.namespacesAddedToMatcher)
      : this.state.namespacesAddedToMatcher;

    // Get rid of duplicate values
    const uniqueList = _.uniqBy(list, item => item.prefix + item.uri);
    return uniqueList;
  };

  /**
   * Creates Xpath/JSON path string of the selected paths in the node tree.
   *
   * @param pathNodes
   * @param selectedNode
   */
  generateNodePathFromTreeArray = (pathNodes: any[], selectedNode: number, attributeId: number) => {
    const index = this.state.leafNodeMatcherValues.findIndex(item => item.id === selectedNode);
    const leafNodeMatcher = this.state.leafNodeMatcherValues[index];
    if (this.props.type === 'xpath') {
      return this.generateXPathFromNodes(pathNodes, leafNodeMatcher, this.state.ignoreNameSpaces, attributeId);
    } else if (this.props.type === 'cdata_xpath') {
      return this.generateXPathFromNodes(pathNodes, leafNodeMatcher, this.state.ignoreNameSpaces, attributeId);
    } else if (this.props.type === 'json') {
      return this.generateJsonPathFromNodes(pathNodes, leafNodeMatcher.matchType, leafNodeMatcher.matchValue);
    } else {
      return '';
    }
  };

  generateXPathFromNodes = (
    pathNodes: any,
    nodeMatcher: LeafNodeMatcherValue,
    ignoreNameSpaces: boolean,
    attributeId: number,
  ) => {
    let xpath = '[[';
    xpath += getXpathForNodeInTree(pathNodes, ignoreNameSpaces);

    let connector = '/text(), ';
    let matchType = nodeMatcher.matchType;
    let matchValue = nodeMatcher.matchValue;
    //-1 is the node itself, so we validate to not include it
    if (attributeId !== undefined && attributeId !== -1) {
      const node = pathNodes.find(pn => pn.id === nodeMatcher.id);
      const attributeNode = node.attributesNode.find(an => an.id === attributeId);
      const name = attributeNode !== undefined ? attributeNode.name : undefined;
      connector = '/@' + name + ',';
      const attrMatcherValue = nodeMatcher.attributesNode.find(an => an.id === attributeId);
      if (attributeId !== undefined) {
        matchType = attrMatcherValue.matchType;
        matchValue = attrMatcherValue.matchValue;
      }
    }
    if (matchType === matcherSpecific) {
      /** Data driven syntax is implicitly handled as a string version.
       * A sample data driven syntax might look like ${userId}. */
      xpath += connector + 'equalTo(' + matchValue + ')]]';
    } else if (matchType === matcherAnything) {
      xpath += connector + 'matching(.*)]]';
    } else {
      xpath += connector + 'matching(' + matchValue + ')]]';
    }
    return xpath;
  };

  /**
   * Builds JSON path string from list of nodes, which represents a path to the leaf selected by user.
   * @param pathNodes
   * @param matcher
   * @param matchValue
   * @param matcher
   * @param matchValue
   */
  generateJsonPathFromNodes = (pathNodes: any, matcher: string, matchValue: string) => {
    let jsonPath = '[[$';
    const connector = '.';

    //Nodes
    jsonPath += getJsonPathForNodeInTree(pathNodes);

    //Leaf
    const connectorPrefix = connector + pathNodes[0].name;
    if (matcher === matcherSpecific) {
      /** Data driven syntax is implicitly handled as a string version.
       * A sample data driven syntax might look like ${userId}. */
      jsonPath += connectorPrefix + ', equalTo(' + matchValue + ')]]';
    } else if (matcher === matcherAnything) {
      jsonPath += connectorPrefix + ', matching(.*)]]';
    } else {
      jsonPath += connectorPrefix + ', matching(' + matchValue + ')]]';
    }
    return jsonPath;
  };

  /**
   * Click on the select checkbox event handler.
   * @param id
   * @param attributeId
   */
  changeSelection = async (id: number, attributeId: number) => {
    const nodes: SelectedElements[] = _.cloneDeep(this.state.selectedNodes);
    const node = nodes.find(n => n.id === id);
    let counterUpdateType: CounterUpdateType = CounterUpdateType.Increment;

    //check the nodes and its attributes, if previously checked then remove it, otherwise checked
    if (node !== undefined) {
      const attributesList = node.attributesId !== undefined ? _.cloneDeep(node.attributesId) : [];
      if (_.includes(attributesList, attributeId)) {
        _.remove(attributesList, attr => attr === attributeId);
      } else {
        attributesList.push(attributeId);
      }
      node.attributesId = attributesList;
      if (node.attributesId.length === 0) {
        _.remove(nodes, item => item.id === id);
        counterUpdateType = CounterUpdateType.Decrement;
      }
    } else {
      nodes.push({ id: id, attributesId: [attributeId] } as SelectedElements);
    }

    await this.setState({
      selectedNodes: nodes,
    });

    //Update counts
    if (this.props.type === 'cdata_xpath') {
      const selectedCdataKey = this.state.selectedCdataItem.name;
      await this.updateCdataCounts(selectedCdataKey, counterUpdateType);
    }

    this.makeCurrentCdataDirty();
  };

  matchTypeSelectHandler = (id: number, item: BlazeDropdownItem, cdataXpathSelected: string | null) => {
    const index = this.state.leafNodeMatcherValues.findIndex(item => item.id === id);
    if (index !== -1) {
      const currentArray = this.state.leafNodeMatcherValues;
      currentArray[index].matchType = item.name;
      this.setState({
        leafNodeMatcherValues: currentArray,
      });
    } else {
      const newEntry: LeafNodeMatcherValue = {
        id: id,
        matchType: item.name,
        matchValue: '',
        cdataXpath: cdataXpathSelected,
      };
      this.state.leafNodeMatcherValues.push(newEntry);
    }

    this.makeCurrentCdataDirty();
  };

  matchValueChangeHandler = (id: number, e: any, cdataXpathSelected: string | null) => {
    const target = e.target as HTMLInputElement;
    const index = this.state.leafNodeMatcherValues.findIndex(item => item.id === id);
    if (index !== -1) {
      const currentArray = this.state.leafNodeMatcherValues;
      currentArray[index].matchValue = target.value;
      this.setState({
        leafNodeMatcherValues: currentArray,
      });
    } else {
      const newEntry: LeafNodeMatcherValue = {
        id: id,
        matchType: specificMatcherItem.name, //Specific by default
        matchValue: target.value,
        cdataXpath: cdataXpathSelected,
      };
      this.state.leafNodeMatcherValues.push(newEntry);
    }

    this.makeCurrentCdataDirty();
  };

  matchAttributeChangeHandler = (
    id: number,
    attributeId: number,
    attributeMatch: AttributeMatch | null,
    cdataXpathSelected: string | null,
  ) => {
    const index = this.state.leafNodeMatcherValues.findIndex(n => n.id === id);
    if (index !== -1 && attributeMatch !== null) {
      const currentArray = this.state.leafNodeMatcherValues;
      const attributeIndex =
        currentArray[index].attributesNode !== undefined
          ? currentArray[index].attributesNode.findIndex(attr => attr.id === attributeId)
          : -1;
      const currentAttributesNode =
        currentArray[index].attributesNode !== undefined ? currentArray[index].attributesNode : [];
      if (attributeIndex !== -1) {
        currentAttributesNode[attributeIndex].matchValue = attributeMatch.value;
        currentAttributesNode[attributeIndex].matchType = attributeMatch.type;
        currentAttributesNode[attributeIndex].cdataXpath = cdataXpathSelected;
      } else {
        const newEntry: AttributesNodeMatcherValue = {
          id: attributeId,
          matchType: specificMatcherItem.name, //Specific by default
          matchValue: attributeMatch.value,
          cdataXpath: cdataXpathSelected,
        };
        currentAttributesNode.push(newEntry);
      }
      currentArray[index].attributesNode = currentAttributesNode;
      this.setState({
        leafNodeMatcherValues: currentArray,
      });

      this.makeCurrentCdataDirty();
    }
  };

  getMatchValueFromState = (id: number, defaultText: string) => {
    const value = this.state.leafNodeMatcherValues.find(item => item.id === id);
    if (!value) {
      return defaultText;
    } else {
      return value.matchValue;
    }
  };

  getAttributeMatchValueFromState = (id: number, attributeId: number, defaultText: string) => {
    const leafNode = this.state.leafNodeMatcherValues.find(item => item.id === id);
    if (!leafNode) {
      return defaultText;
    } else {
      const attribute = leafNode.attributesNode.find(attr => attr.id === attributeId);
      if (!attribute) {
        return defaultText;
      } else {
        return attribute.matchValue;
      }
    }
  };

  getMatchTypeFromState = (id: number, defaultOption: BlazeDropdownItem) => {
    const value = this.state.leafNodeMatcherValues.find(item => item.id === id);
    if (!value) {
      return defaultOption;
    } else {
      return {
        id: value.matchType,
        name: value.matchType,
      };
    }
  };

  getAttributeMatchTypeFromState = (id: number, attributeId: number, defaultOption: BlazeDropdownItem) => {
    const leafNode = this.state.leafNodeMatcherValues.find(item => item.id === id);
    if (!leafNode) {
      return defaultOption;
    } else {
      const attribute = leafNode.attributesNode.find(attr => attr.id === attributeId);
      if (!attribute) {
        return defaultOption;
      } else {
        return {
          id: attribute.matchType,
          name: attribute.matchType,
        };
      }
    }
  };

  /**
   * Makes currently selected CData dirty.
   */
  makeCurrentCdataDirty = () => {
    if (this.props.type === 'cdata_xpath') {
      const { selectedCdataItem, cdataSelectedNodes } = this.state;
      const updatedSelection = _.cloneDeep(cdataSelectedNodes);
      updatedSelection[selectedCdataItem.name].isDirty = true;
      this.setState({ cdataSelectedNodes: updatedSelection });
    }
  };

  /**
   * Update count values of CData blocks.
   * @param cdataKey
   * @param updateType
   */
  updateCdataCounts = (cdataKey: string, updateType: CounterUpdateType) => {
    const cdataCounts = _.cloneDeep(this.state.cdataSelectedCounts);
    const selectedCdataItem = this.state.selectedCdataItem;
    if (_.isNil(selectedCdataItem)) {
      return;
    }

    let cdataItemCountValue = cdataCounts.items[cdataKey];
    if (_.isNil(cdataItemCountValue)) {
      cdataItemCountValue = 0;
    }

    if (updateType === CounterUpdateType.Increment) {
      cdataCounts.items[selectedCdataItem.name] = ++cdataItemCountValue;
      cdataCounts.total = ++cdataCounts.total;
    } else {
      cdataCounts.items[selectedCdataItem.name] = --cdataItemCountValue;
      cdataCounts.total = --cdataCounts.total;
    }
    this.setState({ cdataSelectedCounts: cdataCounts });
  };

  getType = () => {
    switch (this.props.type) {
      case 'cdata_xpath':
      case 'xpath':
      case 'wsdl':
        return 'XML';
      case 'json':
        return 'JSON';
    }
  };

  render() {
    const modalHeaderType =
      this.props.type === 'xpath'
        ? i18n.t('transactions:editor.selectionWizardForXPath')
        : this.props.type === 'cdata_xpath'
        ? i18n.t('transactions:editor.selectionWizardForCdataXPath')
        : i18n.t('transactions:editor.selectionWizardForJsonPath');

    const contentTitle =
      this.props.type === 'xpath' || this.props.type === 'cdata_xpath'
        ? i18n.t('transactions:editor.xmlSample')
        : i18n.t('transactions:editor.jsonSample');

    return (
      <>
        <Button
          disabled={this.props.isReadOnly}
          id={'qa-btn-add-body-matcher' + _.uniqueId()}
          onClick={this.openWidget}
          variant={'link'}
          className="btn btn-link btn-no-hover pull-right mb-1 mt-0 pb-2 pt-0"
          title={i18n.t('transactions:editor.selectionWizard')}
        >
          <BzmIcon variant={'icon-bzm-setup-wizard'} className={'icon-xs'} />
          <span className={'ml-3 font-size-base font-weight-semi-bold text-primary'}>
            {i18n.t('transactions:editor.selectionWizard')}
          </span>
        </Button>
        {this.state.showWidget && (
          <Modal
            id="widget-modal"
            show={this.state.showWidget}
            enforceFocus={false}
            centered={true}
            backdrop={true}
            size={'lg'}
            onHide={() => this.closeModal()}
          >
            <Modal.Header closeButton id="widget-modal-btn-close-icon">
              <Modal.Title>
                <div className={'d-flex'}>
                  <span className={'modal-title-dialog'}>
                    <span className={'text-muted'}>{i18n.t('transactions:editor.selectionWizardFor')}</span>
                    {' ' + modalHeaderType}
                  </span>
                  <HelpTooltip id={'request_response_widgets_help'} className={'ml-3 mt-1'} />
                </div>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className={'mb-5'}>
                <Form.Group controlId={'widget-modal-textarea'} className={'w-auto mb-2'}>
                  {/* Sample Body */}
                  <label className={'font-size-lg font-weight-bold mt-2 mb-2'}>{contentTitle}</label>
                  <div className={'float-right'}>
                    {/* Build Node Tree Action */}
                    <Button
                      onClick={() => {
                        this.formatContentDebounced.cancel();
                        this.formatContent();
                      }}
                      variant={'primary'}
                      size={'sm'}
                      className={'mr-3'}
                      disabled={_.isEmpty(this.state.content) || !this.state.isTreeReady}
                      title={i18n.t('transactions:editor.buildTreeTitle')}
                    >
                      <BzmIcon variant={'icon-bzm-tree-list'} className={'mr-3 icon-xs align-middle'} />
                      <span className={'align-middle'}>{i18n.t('transactions:editor.buildTree')}</span>
                    </Button>

                    {/* Copy To Clipboard  */}
                    <CopyToClipboardButton
                      paddingSize={0}
                      className={'p-0 mr-3'}
                      disabled={_.isEmpty(this.state.content) || !this.state.isTreeReady}
                      id={'copy-widget-content'}
                      textToCopy={this.state.content}
                      title={i18n.t('transactions:editor.copyContent')}
                      customToastMsg={i18n.t('transactions:editor.copyContentSuccessMsg')}
                    >
                      <Button className={'m-0'} variant={'secondary'} size={'sm'}>
                        <BzmIcon variant={'icon-bzm-clipboard'} className={'mr-3 icon-xs align-middle'} />
                        <span className={'align-middle'}>Copy {this.getType()} to Clipboard</span>
                      </Button>
                    </CopyToClipboardButton>
                    {/* ./ Copy To Clipboard  */}

                    {/* Format */}
                    <Button
                      id={'request-selection-wizard' + _.uniqueId()}
                      onClick={() => this.prettifyContent()}
                      variant={'secondary'}
                      size={'sm'}
                      className={'mr-3 '}
                      disabled={_.isEmpty(this.state.content)}
                      title={i18n.t('transactions:editor.formatBody')}
                    >
                      <BzmIcon variant={'icon-bzm-timeline'} className={'mr-3 icon-xs align-middle'} />
                      <span className={'align-middle'}>
                        {i18n.t('transactions:editor.formatBodyByType', { type: this.getType() })}
                      </span>
                    </Button>
                    {/* ./Format */}

                    {/* Reset Content */}
                    <Button
                      onClick={() => this.clearContent()}
                      variant={'secondary'}
                      size={'sm'}
                      disabled={_.isEmpty(this.state.content)}
                      title={i18n.t('transactions:editor.resetTitle')}
                    >
                      <BzmIcon variant={'icon-bzm-refresh'} className={'icon-xs mr-3 align-middle'} />
                      <span className={'align-middle'}>{i18n.t('transactions:editor.reset')}</span>
                    </Button>
                    {/* ./ Reset Content */}
                  </div>
                  <Form.Control
                    as="textarea"
                    rows={8}
                    className={clsx(
                      this.state.sampleBodyParsingErrors.trim().length > 0 ? 'sampleBodyParsingError' : '',
                      'mt-2',
                    )}
                    name="content"
                    onChange={(event: any) => this.handleChange(event)}
                    disabled={!this.state.isTreeReady}
                    value={this.state.content}
                  />
                  {this.state.sampleBodyParsingErrors.trim().length > 0 && (
                    <span className="invalid-feedback">{this.state.sampleBodyParsingErrors}</span>
                  )}
                </Form.Group>
                {/* While a rebuild is in flight, keep whatever tree is already on screen mounted (rather than
                    unmounting it in favor of a much shorter loading placeholder) so the modal's height stays
                    stable and react-bootstrap's centered modal doesn't visibly jump/shake on every rebuild. */}
                {(() => {
                  const hasTreeToShow = this.state.isTreeReady || this.state.sampleBodyJsonUi !== '';
                  return (
                    <div className={'position-relative'}>
                      {!this.state.isTreeReady && (
                        <SimpleLoader
                          className={clsx('mt-5', hasTreeToShow && 'tree-loading-overlay')}
                          loadingText={i18n.t('transactions:editor.loadingNodeText')}
                        />
                      )}

                      {hasTreeToShow && this.props.type !== 'cdata_xpath' && (
                        <RequestTreeWizard
                          sampleBodyJsonUi={this.state.sampleBodyJsonUi}
                          changeSelection={this.changeSelection}
                          selectedNodes={this.state.selectedNodes}
                          nodeTypes={matcherTypesDropdownItems}
                          getMatchTypeFromState={this.getMatchTypeFromState}
                          getAttributeMatchTypeFromState={this.getAttributeMatchTypeFromState}
                          getMatchValueFromState={this.getMatchValueFromState}
                          getAttributeMatchValueFromState={this.getAttributeMatchValueFromState}
                          matchTypeSelectHandler={this.matchTypeSelectHandler}
                          matchValueChangeHandler={this.matchValueChangeHandler}
                          onMatchAttributeChangedHandler={this.matchAttributeChangeHandler}
                          bodyMatcherList={this.props.bodyMatcherList}
                          cdataXpathSelected={null}
                          type={this.props.type}
                        />
                      )}

                      {hasTreeToShow && this.props.type === 'cdata_xpath' && (
                        <>
                          <Row className="mt-3" key={'cdataDropdownLabel'}>
                            <Col md={8}>
                              <CDataDropdown
                                dropdownItems={this.state.cdataItems}
                                selectedItem={this.state.selectedCdataItem}
                                onSelect={this.handleCdataItemSelection}
                                selectedCdataNodesCounts={this.state.cdataSelectedCounts}
                              />
                            </Col>
                          </Row>
                          <RequestTreeWizard
                            key={'cdata-wizard'}
                            sampleBodyJsonUi={this.state.sampleBodyJsonUi}
                            changeSelection={this.changeSelection}
                            selectedNodes={this.state.selectedNodes}
                            nodeTypes={matcherTypesDropdownItems}
                            cdataXpathSelected={this.state.selectedCdataItem ? this.state.selectedCdataItem.name : null}
                            getMatchTypeFromState={this.getMatchTypeFromState}
                            getAttributeMatchTypeFromState={this.getAttributeMatchTypeFromState}
                            getMatchValueFromState={this.getMatchValueFromState}
                            getAttributeMatchValueFromState={this.getAttributeMatchValueFromState}
                            matchTypeSelectHandler={this.matchTypeSelectHandler}
                            matchValueChangeHandler={this.matchValueChangeHandler}
                            onMatchAttributeChangedHandler={this.matchAttributeChangeHandler}
                            bodyMatcherList={this.props.bodyMatcherList}
                            type={this.props.type}
                          />
                        </>
                      )}
                    </div>
                  );
                })()}
              </div>
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: 'space-between' }}>
              <div>
                {(this.props.type === 'xpath' || this.props.type === 'cdata_xpath') && (
                  <CheckBox
                    disabled={!this.state.containsNameSpace}
                    title={i18n.t('transactions:editor.requestTreeWizard.ignoreNamespacesDesc')}
                    onCheck={() => {
                      this.setState({ ignoreNameSpaces: !this.state.ignoreNameSpaces });
                    }}
                    label={i18n.t('transactions:editor.requestTreeWizard.ignoreNamespaces')}
                    checked={this.state.ignoreNameSpaces}
                  />
                )}
              </div>
              <div>
                <Button
                  onClick={this.closeModal}
                  className={'btn btn-link mr-5'}
                  id={'request-modal-btn-select-node' + _.uniqueId()}
                  variant={'link'}
                  title={i18n.t('common:actions.cancel')}
                >
                  {i18n.t('common:actions.cancel')}
                </Button>
                <Button
                  onClick={this.selectNodes}
                  disabled={this.isSelectButtonDisabled()}
                  className={'pl-5 pr-5 close-request-modal-btn'}
                  id={'request-modal-btn-cancel' + _.uniqueId()}
                  title={i18n.t('common:actions.select')}
                >
                  {i18n.t('common:actions.select')}
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </>
    );
  }
}
const mapStateToProps = () => ({});

const mapDispatchToProps = {
  showToastNotification,
};

type MapToStateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
type AllProps = MapToStateProps & DispatchProps & LocalProps;

export default connect(mapStateToProps, mapDispatchToProps)(RequestNodeWidget);
